/**
 * @file Web Galleries access request form container.
 */

import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { mapProps } from '../../../util/hocs';
import { albumFolderAccessRequest } from '../../../graphql/mutations/account';
import { AccountForWebGalleries } from '../graphql/queries/account';
import { AlbumFolderForWebGalleries } from '../graphql/queries/album-folder';
import OnboardingAccessRequestForm from '../../../components/onboarding/access-control/OnboardingAccessRequestForm';
import { prependAccountSlug } from '../../../util/account';

const withUserData = graphql(AccountForWebGalleries, {
  props: ({ data: { me } }) => ({
    user: me,
  }),
  options: {
    fetchPolicy: 'network-only',
  },
  skip: ownProps => !ownProps.authenticated,
});

const withAlbumFolderData = graphql(AlbumFolderForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.folderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
});

const withAlbumFolderAccessRequestMutation = graphql(albumFolderAccessRequest, {
  props: ({ mutate }) => ({
    albumFolderAccessRequest: ({
      albumFolderId,
      firstName,
      lastName,
      phoneNumber,
      emailAddress,
      identityName,
      identityRelation,
      comments,
    }) =>
      mutate({
        variables: {
          input: {
            album_folder_id: albumFolderId,
            first_name: firstName,
            last_name: lastName,
            phone_number: phoneNumber,
            email_address: emailAddress,
            identity_name: identityName,
            relation_to_identity: identityRelation,
            comments: `${comments}\nWeb Gallery\nParent Consent: Yes`,
          },
        },
      }),
  }),
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withUserData,
  withAlbumFolderData,
  withAlbumFolderAccessRequestMutation,
  mapProps(({ ...props }) => ({
    ...props,
    redirectUrl: prependAccountSlug(
      `/galleries/view/folder/${props.albumFolder?.id}`,
      props.albumFolder,
    ),
  })),
)(OnboardingAccessRequestForm);
